import { queryOptions, mutationOptions } from '@tanstack/react-query';
import { sparkApi } from '@api/spark-client';

export interface SummaryResponse {
  summary: string;
  object_name: string;
  record_id: string;
  generated_at: string;
}

export const summaryQueryOptions = (objectName: string | undefined, recordId: string | undefined) =>
  queryOptions({
    queryKey: ['summary', objectName, recordId],
    queryFn: async ({ signal }) => {
      const url = `/api/v1/record-summary/${objectName}/${recordId}`;
      const response = await sparkApi.get<SummaryResponse>(url, {
        signal,
      });
      return response.data;
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled: !!recordId && !!objectName,
  });

export const refreshSummaryMutationOptions = (
  objectName: string | undefined,
  recordId: string | undefined
) =>
  mutationOptions({
    mutationFn: async () => {
      const url = `/api/v1/record-summary/${objectName}/${recordId}/refresh`;

      try {
        const response = await sparkApi.post<SummaryResponse>(
          url,
          {},
          {
            timeout: 5 * 60 * 1000,
          }
        );
        return response.data;
      } catch (error: any) {
        if (error.response?.status === 400) {
          const errorMessage = error.response.data?.error || 'Bad request';
          throw new Error(errorMessage);
        }
        throw error;
      }
    },
  });
